import request from '../network';
import { ComponentType } from '../types/ComponentType';

const apiPath = '/api/data/v1/row/cms_component';

export async function findAllComponentService() {
    const response = await request.GET<ComponentType>(apiPath);
    response.items = response.items.map((t) => new ComponentType(t));
    return response;
}